export const dataTypeList = [
	{
		name: '官方',
		value: '1'
	},
	{
		name: '品牌商',
		value: '2'
	}
]
export const countryList = [
	{
    name: '全部',
    value: '1'
  },
  {
    name: '国内',
    value: '2'
  },
  {
    name: '国外',
    value: '3'
  }
]


// WEBPACK FOOTER //
// ./src/lib/constObj.js